import CircularProgress from "@mui/material/CircularProgress";

const FullScreenLoading = () => {
  return (
    <div className="h-screen w-screen flex flex-col justify-center items-center bg-slate-700 bg-opacity-40 fixed top-0 left-0 z-[9999999]">
      <CircularProgress />
    </div>
  );
};

export default FullScreenLoading;
